var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-7 border rounded-3"},_vm._l((10),function(i){return _c('bildirim-card',{key:i})}),1),_c('sidefix')],1)}
var staticRenderFns = []

export { render, staticRenderFns }